module.exports = __webpack_public_path__ + "static/7991324b.188.png";